import Header from "./components/Header";
import Footer from "./components/Footer";
//FB 7074
import Reply from "./feature/User/Home/Messages/Reply";
//FB 6751
import { CircularProgress, ThemeProvider, Card, createTheme, Dialog, DialogContent, } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./feature/User";
import SignUp from "./feature/User/SignUp/index";
import Login from "./feature/User/SignIn/login";
import ForgotUsername from "./feature/User/SignIn/forgotUsername";
import Dashboard from "./feature/User/Home/dashboard";
import Appointment from "./feature/User/Home/Appointments/index";
import Billing from "./feature/User/Home/Billing/Billing";
import Messages from "./feature/User/Home/Messages";
import Myrecord from "./feature/User/Home/Records";
import { createContext, useEffect, useReducer, useState } from "react";
import { GetEMRURL, GetLogo } from "./api";
import { Navigate } from "react-router-dom";
import { TimeOut } from "./components/TimeOut";
import ForgotPassword from "./feature/User/SignIn/forgotPassword";
import ForgotPasswordVerification from "./feature/User/SignIn/forgotPasswordVerification";
import MakePayment from "./feature/User/Home/Billing/MakePayment";
import ResetPassword from "./feature/User/SignIn/resetPassword";
import SimpleMail from "./feature/User/Home/Messages/SimpleMail";
import SecureMail from "./feature/User/Home/Messages/SecureMail";
import TestResults from "./feature/User/Home/TestResults";
import ResultAnnotation from "./feature/User/Home/TestResults/resultAnnotation";
import ResultDocument from "./feature/User/Home/TestResults/resultDocument";
import Profile from "./feature/User/Home/AccountSettings/Profile";
import Settings from "./feature/User/Home/AccountSettings/Settings";
import PaymentReceipt from "./feature/User/Home/Billing/paymentReceipt";
import AccountAuth from "./feature/User/SignUp/guardianRegistration";
import Configurations from "./config";
import ActivityLog from "./feature/User/Home/AccountSettings/ActivityLog";
import ChatMsg from "./feature/User/Home/Messages/ChatMsg";
import MessageMobileUI from "./feature/User/Home/Messages/MessageMobileUI";
import reducer from "./store/reducer";
import { ApptContext, InitialApptObj } from "./store";
import AppointmentIndex from "./feature/User/Home/Appointments/BookAppointment";
import Confirmation from "./feature/User/Home/Appointments/BookAppointment/ConfirmationPage";
import AppointmentFeatures from "./feature/User/Home/Appointments/BookAppointment/Features";
import CameraComponent from "./feature/User/Home/Appointments/BookAppointment/Features/Camera";
import ClosurePage from "./feature/User/Home/Appointments/BookAppointment/Features/ClosurePage";
import QRCodeComponent from "./feature/User/Home/Appointments/BookAppointment/Features/QRCode";
import Redirector from "./feature/User/Home/Appointments/BookAppointment/Features/Redirector";
import FacilitySchedules from "./feature/User/Home/Appointments/BookAppointment/Slots/FacilitySchedules";
import ProviderSchedules from "./feature/User/Home/Appointments/BookAppointment/Slots/ProviderSchedules";
import Schedules_ByDate from "./feature/User/Home/Appointments/BookAppointment/Slots/SchedulesByDate";
import VideoChat from "./feature/User/Home/Appointments/BookAppointment/Twilio/VideoChat";
import Inbox from "./feature/User/Home/Messages/InboxMessages";
import Reviews from "./feature/User/Home/Appointments/BookAppointment/Features/Reviews";
import FileUpload from "./feature/User/Home/Appointments/BookAppointment/Features/FileUpload";
import AdminLoginPage from "./feature/Admin/SignIn/login";
import AdminDashboard from "./feature/Admin/Home/dashboard";
import FindPatient from "./feature/Admin/Home/find_patient";
import Upload from "./feature/Admin/Home/upload";
import ClinicalDocuments from "./feature/User/Home/ClinicalDocuments";
import LabOrdering from "./feature/User/Home/LabOrdering"; //FB 9464
//FB 6751
import InvalidSite from "./feature/User/invalidSite";
//FB 8099 - Start
import PrivacyPolicy from "./feature/User/Policies/PrivacyPolicy";
import GuestLogin from "./feature/User/SignUp/guestLogin";
import GuestPayment from "./feature/User/SignUp/guestPayment";
import GuestBilling from "./feature/User/SignUp/guestBilling";
import ThankYou from "./feature/User/SignUp/thankYou";
//FB 8099 - End
import { TrackJS } from 'trackjs';  //FB 8480
import Forms from "./feature/User/Home/Forms/Forms"; //FB 10399

// Update log
// FB  6192   02/06/2023  DK  Master page where the routing is defined and implemented
// FB  6751   05/31/2023  SK  Mis-Directed URL: https://aaron.mdchartsportal.com/
// FB  6925   06/06/2023  KK  Upload Doc (Use smartphone)> Updating the QR code with the Dynamic Link
// FB  7074   07/26/2023  SK  Patient Portal : Develop the feature of message reply
// FB  7874   12/07/2023  DK  Admin should be able to access patient pages
// FB  8099   01/17/2024  SK  Add Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
// FB  8480   03/27/2024  DK  JS error handling
// FB  8973   07/02/2024  DK  Guest login enhancements
// FB  9464   10/08/2024  KI  created new screen for displaying lab orders
// FB  10399  04/28/2025  KI  fixing the portalforms loading issue in portal

const defaultContext = {
  userLoggedIn: false,
  setUserLoggedIn: (userLoggedIn: boolean) => { },
};

const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
};

//FB 6751 - Start
const theme = createTheme({
  palette: {
    primary: {
      main: "#083A4D",
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});
//FB 6751 - End

export const getIpDetails = async () => {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    if (response.ok) {
      const clientDetails = await response.json();
      Configurations.clientIp = clientDetails.ip;
      return clientDetails.ip;
    } else {
      throw "Error in calling getIpDetails";
    }
  } catch (e: any) {
    const exceptionMessage = e.message || e;
    console.log(`Error in fetching Ip Details - ${exceptionMessage}`);
    return "";
  }
};

export const UserContext = createContext(defaultContext);

function App() {
  //FB 6751 - Start
  const [showSpinner, setShowSpinner] = useState(false);
  const [emrinfo, setEmrinfo] = useState(false);
  //FB 6751 - End
  const [state, dispatch] = useReducer(reducer, InitialApptObj);
  const user = sessionStorage.getItem("user");
  const [userLoggedIn, setUserLoggedIn] = useState(defaultContext.userLoggedIn);
  const auth = { userLoggedIn, setUserLoggedIn };
  async function GetEMRBaseURL() {
    const result = await GetEMRURL();
    if (result != null) {
      //FB 6751 - Start
      setShowSpinner(false);
      setEmrinfo(true);
      //FB 6751 - End
      sessionStorage.setItem("EMRConfig", JSON.stringify(result));
      sessionStorage.setItem("EMRBaseURL", result.EMRURL);
    } else {
      //FB 6751 - Start
      setShowSpinner(false);
      setEmrinfo(false);
      //FB 6751 - End
      alert("No data");
    }
    GetLogoImage();
  }

  const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    let isLoggedIn = false;
    //FB 8973
    let isGuestLoggedIn = false;
    let isGuestUser = false;
    let user = sessionStorage.getItem("user");
    if (user != null) {
      isLoggedIn = true;
    }

    //FB 8973
    if (children.props.mode != undefined) {
      if (children.props.mode == "guest") {
        isGuestUser = true;
        let guest = sessionStorage.getItem("PatientInfo");
        if (guest != null) {
          isGuestLoggedIn = true;
        }
      }
    }
    
    //FB 8973
    return isGuestUser ? (isGuestLoggedIn ? children : <Navigate to="/user/guestLogin" />)
      : (isLoggedIn ? children : <Navigate to="/user/login" />);
  };

  const [logo, setLogo] = useState("");
  async function GetLogoImage() {
    var img = await GetLogo();
    if (img != null && img != undefined) {
      setLogo(img);
    }
  }

  useEffect(() => {
    clearCacheData();
    //FB 6751 - Start
    setShowSpinner(true);
    GetEMRBaseURL();
    //FB 6751 - End
    if (
      sessionStorage.getItem("EMRConfig") == null ||
      sessionStorage.getItem("EMRConfig") == undefined
    ) {
      GetEMRBaseURL();
    }

    //FB 8480
    TrackJS.install({
      token: '281bcfb669fa4d8ebf2836dd4658ef74',
      enabled: window.location.hostname == "localhost" ? false : true,
      version: "Portal: " + window.location.hostname
    });
  }, []);

  return (
    <div>
      <UserContext.Provider value={auth}>
        <BrowserRouter>
          {/* FB 6751 */}
          {emrinfo == true && <Header src={logo} />}
          <Card
            style={{
              margin: "0px auto auto auto",
              minHeight: !(window.innerWidth < 768) ? "80vh" : "auto",
              boxShadow: "0 3px 5px 2px lightgray",
            }}
          >
            <ApptContext.Provider value={{ state, dispatch }}>
              <Routes>
                {/* FB 6751 -  Start */}
                <Route
                  path={emrinfo == true ? "/" : "/"}
                  element={emrinfo == true ? <Home /> : <InvalidSite />}
                />
                {/* FB 6751 - End */}
                <Route path="/user/signup" element={<SignUp />} />
                <Route path="/user/login" element={<Login />} />
                <Route
                  path="/user/forgotusername"
                  element={<ForgotUsername />}
                />
                <Route
                  path="/user/forgotpassword"
                  element={<ForgotPassword />}
                />
                <Route
                  path="/user/forgotpassword/verification"
                  element={<ForgotPasswordVerification />}
                />
                <Route path="/user/resetpassword" element={<ResetPassword />} />
                {/* FB 8099 - Start */}
                <Route
                  path="/privacypolicy"
                  element={
                    <PrivacyPolicy />
                  }
                />
                <Route
                  path="/user/guestLogin"
                  element={
                    <GuestLogin />
                  }
                />
                {/* FB 8973 */}
                <Route
                  path="/user/guestPayment"
                  element={
                    <PrivateRoute>
                      <GuestPayment mode="guest" />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/guestBilling"
                  element={
                    <PrivateRoute>
                      <GuestBilling mode="guest" />
                    </PrivateRoute>
                  }
                />
                {/* FB 8099 - End */}
                <Route
                  path="/user/home/MakePayment"
                  element={
                    <PrivateRoute>
                      <MakePayment />
                    </PrivateRoute>
                  }
                />
                {/* FB 8099 */}
                <Route
                  path="/payment/printReceipt"
                  element={<PaymentReceipt />}
                />
                {/* FB 8099 */}
                <Route
                  path="/ThankYou"
                  element={<ThankYou />}
                />
                <Route
                  path="/user/home/SimpleMail"
                  element={
                    <PrivateRoute>
                      <SimpleMail />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/SecureMail"
                  element={
                    <PrivateRoute>
                      <SecureMail />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/ChatMsg"
                  element={
                    <PrivateRoute>
                      <ChatMsg />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/Inbox"
                  element={
                    <PrivateRoute>
                      <Inbox />
                    </PrivateRoute>
                  }
                />
                {/* FB 7874 */}
                <Route
                  path="/user/home/Settings"
                  element={
                    <PrivateRoute>
                      <Settings userType="patient" />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/Profile"
                  element={
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/register/guardian"
                  element={
                    <PrivateRoute>
                      <AccountAuth />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/activitylog"
                  element={
                    <PrivateRoute>
                      <ActivityLog />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/MessageMobileUI"
                  element={
                    <PrivateRoute>
                      <MessageMobileUI />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/dashboard"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
				{/* FB 10399 */}
                <Route
                  path="/user/home/Forms"
                  element={
                    <PrivateRoute>
                      <Forms />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/appointments"
                  element={
                    <PrivateRoute>
                      <Appointment />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/Messages"
                  element={
                    <PrivateRoute>
                      <Messages />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/testresults"
                  element={
                    <PrivateRoute>
                      <TestResults />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/resultannotation"
                  element={
                    <PrivateRoute>
                      <ResultAnnotation />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/resultdocument"
                  element={
                    <PrivateRoute>
                      <ResultDocument />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/Billing"
                  element={
                    <PrivateRoute>
                      <Billing />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/Myrecord"
                  element={
                    <PrivateRoute>
                      <Myrecord />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/index"
                  element={
                    <PrivateRoute>
                      <AppointmentIndex />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/provider/slots"
                  element={
                    <PrivateRoute>
                      <ProviderSchedules />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/facility/slots"
                  element={
                    <PrivateRoute>
                      <FacilitySchedules />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/date/slots"
                  element={
                    <PrivateRoute>
                      <Schedules_ByDate />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/confirmation"
                  element={
                    <PrivateRoute>
                      <Confirmation />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={
                    "/user/bookappointment/features/:apptId/:licenseName/:flag"
                  }
                  element={
                    <PrivateRoute>
                      <AppointmentFeatures />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/fileupload/:apptId"
                  element={
                    <PrivateRoute>
                      <FileUpload />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/fileupload/qrcode/:apptId/:docType"
                  element={
                    <PrivateRoute>
                      <QRCodeComponent />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/fileupload/camera/:apptId/:docType"
                  element={
                    // FB  6925 KK  BEGIN REMOVED PRIVATE ROUTE
                    <CameraComponent />
                    // FB  6925 KK END
                  }
                />
                <Route
                  path="/user/redirect/:urlcode"
                  element={
                    <PrivateRoute>
                      <Redirector />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/appointments/reviews/:id/:flag"
                  element={
                    <PrivateRoute>
                      <Reviews />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/appointment/tele/:patient/:room"
                  element={
                    <PrivateRoute>
                      <VideoChat />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/bookappointment/closure"
                  element={
                    <PrivateRoute>
                      <ClosurePage />
                    </PrivateRoute>
                  }
                />
                {/* FB 7074 -Begin */}
                <Route
                  path="/user/home/Reply"
                  element={
                    <PrivateRoute>
                      <Reply />
                    </PrivateRoute>
                  }
                />
                {/* FB 7074 -End */}
                <Route path="/admin" element={<AdminLoginPage />} />
                <Route
                  path="/admin/home/dashboard"
                  element={
                    <PrivateRoute>
                      <AdminDashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/find_patient"
                  element={
                    <PrivateRoute>
                      <FindPatient />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/update_logo"
                  element={
                    <PrivateRoute>
                      <Upload />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/user/home/clinicaldocuments"
                  element={
                    <PrivateRoute>
                      <ClinicalDocuments />
                    </PrivateRoute>
                  }
                />
                {/* FB 9464 */}
                <Route
                  path="/user/home/LabOrdering"
                  element={
                    <PrivateRoute>
                      <LabOrdering />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </ApptContext.Provider>
          </Card>
          {window.location.pathname == "/" && window.innerWidth < 768 ? (
            <></>
          ) : (
            <Footer />
          )}
          <TimeOut />
        </BrowserRouter>
      </UserContext.Provider>
      {/* FB 6751 -Start */}
      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
      {/* FB 6751 -End */}
    </div>
  );
}

export default App;
